import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  MapPin,
  Store,
  Ticket,
  Building2,
  Calendar,
  Activity,
  Package,
  Users,
  Tags,
  List,
  ClipboardList,
  Tent,
  ShoppingCart,
  Settings,
  LayoutDashboard
} from 'lucide-react';

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(true);
  
  const paramsItems = [
    { path: '/backoffice/villes', icon: <MapPin size={20} />, text: 'Villes' },
    { path: '/backoffice/categories', icon: <Tags size={20} />, text: 'Catégories de produits' },
    { path: '/backoffice/types-points-vente', icon: <Store size={20} />, text: 'Types de points de vente' },
    { path: '/backoffice/types-tickets', icon: <Ticket size={20} />, text: 'Types de Ticket' },
    { path: '/backoffice/types-activites', icon: <ClipboardList size={20} />, text: 'Types d\'activités' },
    { path: '/backoffice/points-ventes', icon: <Building2 size={20} />, text: 'Points de Vente' },
    { path: '/backoffice/utilisateurs', icon: <Users size={20} />, text: 'Utilisateurs' },
    { path: '/backoffice/configurations', icon: <Settings size={20} />, text: 'Configurations' },
  ];
  

  const entitiesItems = [
    { path: '/backoffice', icon: <LayoutDashboard size={20} />, text: 'Tableau de bord' },
    { path: '/backoffice/evenements', icon: <Calendar size={20} />, text: 'Événements' },
    { path: '/backoffice/activites', icon: <Activity size={20} />, text: 'Activités' },
    { path: '/backoffice/tickets', icon: <Ticket size={20} />, text: 'Tickets' },
    { path: '/backoffice/produits', icon: <Package size={20} />, text: 'Produits' },
    { path: '/backoffice/tentes', icon: <Tent size={20} />, text: 'Tentes' },
    // { path: '/backoffice/invites', icon: <Users size={20} />, text: 'Invités' },
    { path: '/backoffice/commandes', icon: <ShoppingCart size={20} />, text: 'Commandes' },
  ];

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`overflow-y-scroll sidebar ${isOpen ? '' : 'closed'}`}>
      {/* Header */}
      <div className="sidebar-brand">
        <div className="logo d-flex align-items-center">
          <img 
            src='/logo.png'
            alt="Logo" 
            className="me-2" 
            style={{ height: "24px" }}
          />
          <span style={{ 
            fontFamily: 'Chantal',
            fontSize: '22px',
            letterSpacing: '0.5px'
          }}>
            VODUN DAYS
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {/* Entités Section */}
        <div className="nav-section">
          <div className="section-title">
            <List size={18} />
            <span>FONCTIONNALITÉS</span>
          </div>
          {entitiesItems.map((item, index) => (
            <Link
              key={`entity-${index}`}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.icon}
              <span>{item.text}</span>
            </Link>
          ))}
        </div>

        {/* Paramètres Section */}
        <div className="nav-section">
          <div className="section-title">
            <List size={18} />
            <span>PARAMÈTRES</span>
          </div>
          {paramsItems.map((item, index) => (
            <Link
              key={`param-${index}`}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.icon}
              <span>{item.text}</span>
            </Link>
          ))}
        </div>

      </nav>
    </div>
  );
};

export default Sidebar; 